export default __webpack_public_path__ + "static/media/SaiLogo.a0aae93b.png";